<script>

    import Vue from 'vue';
    import DefaultServerTable from '../../Libraries/ServerTable/DefaultServerTable';

    export default {

        extends:DefaultServerTable,

        methods: {
            getTemplates() {
                axios.get(this.templatesUri)
                .then(resp => {
                    resp.data.data.forEach(template => {
                        Vue.set(this.$refs.serverTable.filters, template.uuid, {
                            name:template.name,
                            id:template.uuid,
                            enabled:false,
                            onChange:() => {
                                this.$refs.serverTable.resetData();
                            },
                        });
                    });
                });
            }
        },

        mounted() {
            this.getTemplates();
        },

        name:"DocumentsServerTable",

        props: {
            templatesUri: { required:true },
        },

    }

</script>
